module.exports = "/img/_/_/_/assets/images/creeper/battle/epic//7.jpg?062abb9189db980c4b6c9847613b84e9";